export const UPDATE = 'UPDATE_MY_CHATS';
export const UPDATE_CURRENT_CHAT = 'UPDATE_CURRENT_CHATVIEW';
